const initialState = {
  lists: [],
  details: [],
  kiban: [],
  searchFilter: {
    query: '',
    sid: '',
    vulInfo: '',
    url: ''
  }
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const historyReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_HISTORY_DATA':
      return { ...state, lists: action.payload.data };
    case 'GET_DETAIL_DATA': {
      const { id, data } = action.payload;

      const existingDetailIndex = state.details.findIndex((detail) => detail.id === id);

      let newDetails;
      if (existingDetailIndex !== -1) {
        newDetails = state.details.map((detail, index) => (index === existingDetailIndex ? { id, data } : detail));
      } else {
        newDetails = [...state.details, { id, data }];
      }

      return { ...state, details: newDetails };
    }
    case 'GET_KIBAN_DATA':
      return { ...state, kiban: action.payload.data };
    case 'SET_HISTORY_SEARCH_FILTER':
      return { ...state, searchFilter: { ...state.searchFilter, ...action.payload } };
    default:
      return state;
  }
};

export default historyReducer;
